import { env_externalservices } from 'env';
import { baierAdvisorId } from 'config';
import { getAdvisorId } from 'utils';

// Пользователи консультанта Bayer (раздел «Визиты», препараты Байер во
// вредных объектах). Без внешних сервисов проверка не применяется.
export const isBayerAdvisorUser = () =>
  env_externalservices !== 'true' || +getAdvisorId() === baierAdvisorId;
